// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3npis","modalForm":"UpgradeEpcsModal_modalForm__dxG--","modalFooter":"UpgradeEpcsModal_modalFooter__1dFoL"};